export default __webpack_public_path__ + "static/media/signlog.4f393f9a.jpg";